import type { AppState } from 'state/state.model';

import type { AddonManagmenetFormsRequest } from './addonManagement.model';

export function isAddonManagementWorkspaceLoading(state: AppState) {
  return state.workspaces.addonManagement.isLoading;
}

export function getAddonManagementWorkspaceLoading(state: AppState) {
  return state.workspaces.addonManagement.error;
}

export function getIsTradesFetchSuccessful(state: AppState) {
  return state.workspaces.addonManagement.isTradesFetchSuccessful;
}
export function getFiltersToPersist(state: AppState) {
  return state.workspaces.addonManagement.filters;
}

export function getFormsRequest(state: AppState): AddonManagmenetFormsRequest {
  const filters = state.workspaces.addonManagement.filters;
  return {
    issueDateOnAndAfter: filters.issueDateOnAndAfter,
    clientBdrId: filters.client?.id,
    productType: filters.productFilter,
  };
}
